import React from 'react';
import { Feature, WidgetService } from '@tencent/workbench';
import BaseMobileContextMenuFeature from '@framework/workbench/common/feature/base-mobile-context-feature';
import { config } from './config';
import AttachmentActionSheet from './components/attachment-action-sheet';

@Feature()
export class SwitchShowTypeFeature extends BaseMobileContextMenuFeature {
    public id = config.name;

    public constructor(private widgetService: WidgetService) {
        super();
    }

    public renderAttachmentActionSheet() {
        this.widgetService.embed({
            name: 'slide-attachment-action-sheet',
            component: (
                <AttachmentActionSheet
                    uiModel={this.getSelectionService().selectedElements.getCurrentModel()}
                />
            ),
        });
    }
}
